<sk-modal-content [title]="getTitle()"
                  cancelBtnText="label.Close"
                  confirmByKeypress
                  (cancelled)="closeWithoutResult()"
                  (confirmed)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    @if (status$ | async; as status) {
      <dl>
        <dt>{{'label.InstanceId' | translate}}</dt>
        <dd>{{status.instanceId}}</dd>
        <dt>{{'label.ApplicationStartDate' | translate}}</dt>
        <dd>{{status.startDate | irisTime:'yyyy-MM-dd HH:mm:ss':'Europe/Moscow'}}</dd>
        <dt>{{'label.ReleaseVersion' | translate}}</dt>
        <dd>{{status.releaseVersion}} (build: {{status.buildNumber}})</dd>
        <dt>{{'label.GitCommit' | translate}}</dt>
        <dd>{{status.gitCommit}}</dd>
        <dt>{{'label.FrontendReleaseVersion' | translate}}</dt>
        <dd>{{env.version}}</dd>
        <dt>{{'label.DeploymentDate' | translate}}</dt>
        <dd>{{status.buildDate | irisTime:'yyyy-MM-dd HH:mm:ss'}}</dd>
        <dt>{{'label.InstanceType' | translate}}</dt>
        <dd>{{(status.isProd ? 'label.ProdInstance' : 'label.TestInstance') | translate}}</dd>
      </dl>
      @if (status?.lastCommits?.length > 0) {
        <span class="title">
          {{'label.about.LastCommits' | translate }}
        </span>
        <div class="last-commits">
          <div class="d-flex">
            <div class="flex-col-2 px-2">
              <span class="last-commits-header-cell">
                {{ 'label.about.CommitSHA' | translate }}
              </span>
            </div>
            <div class="flex-col-auto px-2">
              <span class="last-commits-header-cell">
                {{ 'label.about.CommitMessage' | translate }}
              </span>
            </div>
          </div>
          <div class="last-commits-body">
            @for (item of status?.lastCommits; track item.commitSha; let last = $last) {
              <div class="d-flex">
                <div class="flex-col-2 px-2">
                  <span class="last-commits-cell">
                    {{ item.commitSha }}
                  </span>
                </div>
                <div class="flex-col-auto px-2">
                  <span class="last-commits-cell">
                    {{ item.commitMessage }}
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (requestErrors.length) {
        <div class="wrapper">
          <div class="title">
            {{'label.about.LastErrors' | translate}}
          </div>
          <sk-button appearance="outlined"
                     data-test="about-clear-button"
                     tabindex="-1"
                     [label]="'label.Clear' | translate"
                     (click)="clearErrors()">
            <ng-template buttonPrefix>
              <i class="icon fa fa-trash-alt fa-fw"></i>
            </ng-template>
          </sk-button>
        </div>
        <div class="request-errors">
          <mat-list class="list">
            @for (item of requestErrors; track item; let last = $last) {
              <mat-list-item class="list-item">
                <div class="flex-col-auto py-3">
                  <div class="flex-row">
                    <div class="flex-col-2 text-right">Request ID:</div>
                    <div class="flex-col-auto ps-2">
                      @if (item.requestId) {
                        <sk-button appearance="icon"
                                   data-test="about-copy-reqid-button"
                                   size="sm"
                                   (click)="onCopy(item.requestId, 'text.ErrorRequestId')">
                          <i class="icon far fa-copy"></i>
                        </sk-button>
                        <span>{{item.requestId}}</span>
                      } @else {
                        &mdash;
                      }
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="flex-col-2 text-right">Request URL:</div>
                    <div class="flex-col-auto ps-2">{{item.method}} {{item.status}} {{item.url}}</div>
                  </div>
                  <div class="flex-row">
                    <div class="flex-col-2 text-right">Date:</div>
                    <div class="flex-col-auto ps-2">{{item.date | irisTime}}</div>
                  </div>
                  <div class="flex-row">
                    <div class="flex-col-2 text-right">URL:</div>
                    <div class="flex-col-auto ps-2"><a href="{{item.pathname}}">{{item.pathname}}</a></div>
                  </div>
                </div>
                @if (item.stack) {
                  <sk-button appearance="solid"
                             data-test="about-copy-stack-button"
                             (click)="onCopy(item.stack, 'text.ErrorStackCopied')">
                    <ng-template buttonPrefix>
                      <i class="icon fal fa-debug"></i>
                    </ng-template>
                  </sk-button>
                }
                <sk-button appearance="solid"
                           data-test="about-copy-item-button"
                           (click)="onCopy(item, 'text.ErrorCopied')">
                  <ng-template buttonPrefix>
                    <i class="icon far fa-copy"></i>
                  </ng-template>
                </sk-button>
                @if (!last) {
                  <mat-divider></mat-divider>
                }
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
    }
  </ng-container>
</sk-modal-content>
